import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	HostBinding,
	Input,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
} from "@angular/core";
import { select, Store } from "@ngrx/store";
import { CoreState, Jurisdiction, JurisdictionSelector } from "@obg/ngx.core";
import { AccordionToggleChangeArgs } from "@obg/ngx.ui.global";
import { Subscription } from "rxjs";
import { filter, tap } from "rxjs/operators";

import { ACCORDION_ICON } from "./sm-terms-and-conditions-accordon.const";

@Component({
	selector: "obg-m-sm-terms-and-conditions-accordion",
	templateUrl: "./sm-terms-and-conditions-accordion.component.html",
	styleUrls: ["./sm-terms-and-conditions-accordion.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SmTermsAndConditionsAccordionComponent implements OnInit, OnDestroy {
	@HostBinding("class.obg-m-sm-terms-and-conditions-accordion") hostClass = true;

	@Input() content: string | undefined;

	accordionIconName = ACCORDION_ICON.open;
	expandedAccordion: string | undefined;

	private jurisdiction$$: Subscription | undefined;

	constructor(
		private store: Store<CoreState>,
		private changeDetector: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.jurisdiction$$ = this.store
			.pipe(
				select(JurisdictionSelector.get),
				filter((jurisdiction) => jurisdiction === Jurisdiction.Dga || jurisdiction === Jurisdiction.Ukgc),
				tap(() => {
					this.expandedAccordion = "terms";
					this.accordionIconName = ACCORDION_ICON.close;
				})
			)
			.subscribe(() => this.changeDetector.detectChanges());
	}

	ngOnDestroy() {
		if (this.jurisdiction$$) {
			this.jurisdiction$$.unsubscribe();
		}
	}

	onToggleChange(group: AccordionToggleChangeArgs) {
		this.accordionIconName = group.isExpanded ? ACCORDION_ICON.close : ACCORDION_ICON.open;
	}
}
